<template lang="pug">
#modal-header-planilha
    el-dialog.modal-header-planilha-content(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='50%'
    )
        span(slot='title')
            h3
                b {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.erroUploadVerificacao') }}

        .modal-header-planilha-content__container
            .container-header-table
                .tabela-customizada
                    .tabela-header
                        .header-campo {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.campo') }}
                        .header-erro {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.erro') }}

                    .tabela-body
                        .item-erro(
                            v-for='(item, index) in dadosPaginado',
                            :key='index'
                        )
                            .linha-principal
                                .campo-valor
                                    strong {{ item.campo }}
                                .erro-valor {{ item.erro }}
                            .linha-detalhes
                                .linhas-afetadas
                                    span.label-linhas {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.erroLinhas') }}
                                    span.numeros-linhas {{ Array.isArray(item.linhas) ? item.linhas.join(', ') : '-' }}

            .cadastro-contrato-originacao__paginador
                b {{ qtdItens }}
                el-pagination(
                    small,
                    background,
                    layout='prev, pager, next',
                    :page-size='paginacao.tamanho',
                    :current-page.sync='paginacao.pagina',
                    :total='dados?.length',
                    @current-change='mudarPagina'
                )

        footer.my-3(slot='footer')
            .btn-opcao
                div
                    el-button(type='primary', @click='fecharModal')
                        | {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.fechar') }}
</template>

<script>
import formatters from '@/utils/formatters';
import { mapGetters } from 'vuex';

export default {
    name: 'ModalErroProcessamentoVerificacao.vue',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        dados: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            paginacao: {
                pagina: 0,
                tamanho: 3,
                total: 0
            },
            alertDados: {
                type: '',
                msg: ''
            }
        };
    },

    watch: {
        show: function () {
            if (!this.show) return;
            this.resetModal();
        }
    },

    computed: {
        ...mapGetters(['usuarioLogado']),

        qtdItens() {
            const total = this.dados?.length ?? 0;
            const key =
                total === 1
                    ? 'mensagens.operacao.monitoramento.registros'
                    : 'mensagens.comuns.registro';

            return `${total} ${this.$t(key)}`;
        },

        dadosPaginado() {
            const inicio = (this.paginacao.pagina - 1) * this.paginacao.tamanho;
            const fim = inicio + this.paginacao.tamanho;

            return this.dados.slice(inicio, fim);
        },

        somarTonelada() {
            let soma = 0;
            this.dados.forEach(item => {
                const valor = item['Volume'].replace(',', '.');
                const numero = parseFloat(valor);
                if (!isNaN(numero)) {
                    soma += numero;
                }
            });
            return soma;
        }
    },

    methods: {
        resetModal() {
            this.paginacao.pagina = 1;
            this.alertDados = {
                type: '',
                msg: ''
            };
        },

        mudarPagina(currentPage) {
            this.paginacao.pagina = currentPage;
        },

        formatarCpfCnpj(valor) {
            if (
                /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(valor) ||
                /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(valor)
            ) {
                return valor;
            } else {
                return formatters.numeralStringFormatTocpfCnpj(
                    valor.replace(/\D/g, '')
                );
            }
        },

        fecharModal() {
            try {
                this.$messageBox
                    .confirm(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.confirmarModal'
                        ),
                        this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.aviso'
                        ),
                        {
                            confirmButtonText: this.$t(
                                'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.confirmar'
                            ),
                            cancelButtonText: this.$t(
                                'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalProcessamentoRastrabilidade.cancelar'
                            ),
                            type: 'warning'
                        }
                    )
                    .then(() => {
                        this.$emit('voltar');
                    })
                    .catch(() => {});
            } catch (erro) {}
        },

        async analisarImoveis() {
            this.$emit('analisarImoveisBackground');
        },

        formatarTonelada(valor) {
            if (valor) {
                const valorString = valor.toString();
                const index = valorString.indexOf('.');
                if (index > -1) {
                    const qtdCasasDecimais = valorString.substring(
                        index + 1
                    ).length;
                    const casasDecimais = qtdCasasDecimais >= 3 ? 3 : 2;
                    return formatters.formatNumber(valor, casasDecimais);
                }
                return formatters.formatNumber(valor, 2);
            }
            return '-';
        }
    }
};
</script>

<style lang="scss">
#modal-header-planilha {
    .el-dialog {
        max-height: 600px;
        overflow-y: auto;
        .el-dialog__footer {
            padding: 10px 33px !important;
        }
    }
    .el-pagination.is-background .el-pager li {
        width: 30px;
        height: 28px;
        font-size: 13px;
        padding-top: 4px;
        display: inline-block;
    }
    .cadastro-contrato-originacao__paginador {
        margin: 0 !important;
        padding: 10px 33px !important;
        b {
            font-size: 13px !important;
        }
    }
    .el-pagination button {
        min-width: 30px;
        height: 30px;
        font-size: 15px;
    }
    footer {
        display: flex;
        justify-content: space-between;
    }

    // Estilos para a tabela customizada
    .tabela-customizada {
        border: 1px solid #ebeef5;
        border-radius: 11px;
        overflow: hidden;
        background-color: white;

        .tabela-header {
            display: flex;
            background-color: #fbfbfb;
            border-bottom: 1px solid #ebeef5;

            .header-campo,
            .header-erro {
                padding: 15px 25px;
                font-weight: 600;
                color: #909399;
                font-size: 14px;
            }

            .header-campo {
                width: 300px;
                flex-shrink: 0;
            }

            .header-erro {
                flex: 1;
            }
        }

        .tabela-body {
            .item-erro {
                border-bottom: 1px solid #ebeef5;

                &:last-child {
                    border-bottom: none;
                }

                .linha-principal {
                    display: flex;
                    align-items: stretch;
                    min-height: 50px;

                    .campo-valor,
                    .erro-valor {
                        padding: 15px 25px;
                    }

                    .campo-valor {
                        width: 300px;
                        flex-shrink: 0;
                        border-right: 1px solid #ebeef5;
                        background-color: #fafafa;

                        strong {
                            color: #303133;
                            font-weight: 600;
                        }
                    }

                    .erro-valor {
                        flex: 1;
                        color: #606266;
                        line-height: 1.4;
                    }
                }

                .linha-detalhes {
                    background-color: #f8f9fa;
                    border-top: 1px solid #e9ecef;

                    .linhas-afetadas {
                        padding: 12px 25px;
                        font-size: 12px;
                        border-left: 3px solid #e6a23c;
                        background-color: #fff8f0;

                        .label-linhas {
                            font-weight: 600;
                            color: #606266;
                            margin-right: 5px;
                        }

                        .numeros-linhas {
                            color: #e6a23c;
                            font-weight: 500;
                        }
                    }
                }
            }
        }
    }
}

.modal-header-planilha-content {
    .el-dialog__header {
        padding: 20px 33px !important;
        padding-bottom: 10px;
        background: var(--primary) !important;
        color: var(--white);
        padding-bottom: 12px;
        padding-top: 12px;
    }
    .el-dialog__body {
        padding: 20px 20px 30px 20px;
        word-break: break-word;
    }
    .el-dialog__headerbtn {
        top: 10px;
    }
    .el-dialog__headerbtn:hover .el-icon-close {
        color: #ffffff;
    }
    .modal-analise-elegibilidade--header {
        display: flex;
        align-items: center;
    }
    .container-header-table__infor {
        margin-bottom: 18px;

        .el-alert__title {
            color: #3b3b3b !important;
        }
    }
    .container-header-table {
        h4 {
            margin-bottom: 16px;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }
    }
    .container-header-pagination {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .spans-paginacao {
            display: flex;
            gap: 21px;
            color: #183b57;
            font-weight: bold;
        }
    }

    .btn-opcao .el-button {
        min-width: 153px;
    }
}
</style>
